import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Button, IInputProps, Icon } from "native-base";
import React, { useState } from "react";

import TextInput from "../TextInput";

type ComponentProps = IInputProps;

const SecureTextInput = (props: ComponentProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextInput
      {...props}
      type={showPassword ? "text" : "password"}
      InputRightElement={
        <Button variant={"ghost"} m={0} p={0} onPress={() => setShowPassword((prev) => !prev)}>
          <Icon
            as={<MaterialCommunityIcons name={showPassword ? "eye-off" : "eye"} />}
            size="md"
            m={2}
          />
        </Button>
      }
    />
  );
};

export default SecureTextInput;
